'use client';

import Link from '@ui/components/Link/Link';
import { CampaignFragment } from '@business/gql/graphql';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useMemo } from 'react';
import { Dictionary } from '@ts/dictionary';
import { cn } from '@ngg/storefront-utils';
import config from '@utils/config';
import ProductListCarousel from '@ui/components/ProductList/ProductListCarousel';
import { CarouselItem } from '@ui/components/Carousel/Carousel';
import { CampaignCarouselItem } from './CampaignCarouselItem';
import Paragraph from '@ui/components/Paragraph/Paragraph';

export default function CampaignsCarousel({
  campaigns,
  dictionary,
  termsLink,
  withHeader,
}: {
  campaigns: Maybe<CampaignFragment>[];
  dictionary: Dictionary;
  termsLink?: string | null;
  withHeader?: boolean;
}) {
  const { locale } = config;

  return (
    <>
      {withHeader && (
        <div className="flex items-center justify-between text-xxxs font-bold uppercase">
          <Paragraph>
            {(campaigns.length ?? 0) > 0 && `${campaigns.length} `}
            {dictionary.campaignCountSuffix}
          </Paragraph>
          {termsLink && (
            <Link locale={locale} href={termsLink}>
              <Paragraph className="underline">
                {dictionary.campaignTerms}
              </Paragraph>
            </Link>
          )}
        </div>
      )}
      <div className={cn(withHeader && 'my-4')}>
        <ProductListCarousel
          contentClassName={cn(
            'lg:flex lg:gap-4',
            campaigns.length >= 4 && 'lg:justify-between',
          )}
          previousClassName="left-0 visible -translate-y-20"
          nextClassName="right-0 visible -translate-y-20">
          {campaigns.map((campaign, index) => (
            <CarouselItem
              key={`${campaign?.commerceId}_${index}`}
              className="lg:last-pr-0 basis-[100%] pr-0 md:basis-[40%] md:pr-4 lg:basis-[24%] lg:pr-0">
              <CampaignCarouselItem
                campaign={campaign}
                dictionary={dictionary}
              />
            </CarouselItem>
          ))}
        </ProductListCarousel>
      </div>
    </>
  );
}
